import {
  Component, EventEmitter, Input, OnDestroy, OnInit,
  Output, ViewEncapsulation
} from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslocoCurrencyPipe, TranslocoDecimalPipe } from '@jsverse/transloco-locale';
import { TableColumnInfo, TypeOfColumn } from '../list-page/list-page.utils';
import { Subscription } from 'rxjs';

export interface SortColumn {
  column: string;
  direction: 'asc' | 'desc';
}

@Component({
  selector: 'ui-table-view',
  imports: [
    MatTableModule, FontAwesomeModule, CommonModule,
    NgClass, MatCardModule, TranslocoCurrencyPipe, TranslocoDecimalPipe,
  ],
  templateUrl: './table-view.html',
  styleUrl: './table-view.scss',
  encapsulation: ViewEncapsulation.None,
})
export class TableView implements OnInit, OnDestroy {
  TypeOfColumn = TypeOfColumn;

  @Input() data: any[] = [];
  @Input() columnsInfo: TableColumnInfo[] = [];
  @Input() set sortColumns(value: SortColumn[]) {
    this.currentSortColumns = value ?? [];
  }

  @Output() sortChange = new EventEmitter<SortColumn[]>();
  @Output() rowClicked = new EventEmitter<any>();
  @Output() reloadData = new EventEmitter<void>();

  // Passato ai componenti di colonna per triggerare il reload nel parent
  reloadDataEmitter = new EventEmitter<any>();
  private reloadSub: Subscription;

  currentSortColumns: SortColumn[] = [];

  get displayedColumns() {
    return this.columnsInfo.map(c => c.columnNameDef);
  }

  ngOnInit() {
    this.reloadSub = this.reloadDataEmitter.subscribe(() => {
      this.reloadData.emit();
    });
  }

  ngOnDestroy() {
    this.reloadSub?.unsubscribe();
  }

  handleMultiSortEvent(columnName: string): void {
    const idx = this.currentSortColumns.findIndex(s => s.column === columnName);
    if (idx !== -1) {
      const currentSort = this.currentSortColumns[idx];
      if (currentSort.direction === 'asc') {
        this.currentSortColumns = [{ column: columnName, direction: 'desc' }];
      } else {
        this.currentSortColumns = [];
      }
    } else {
      this.currentSortColumns = [{ column: columnName, direction: 'asc' }];
    }
    this.sortChange.emit([...this.currentSortColumns]);
  }

  isColumnSorted(columnName: string): boolean {
    return this.currentSortColumns.some(s => s.column === columnName);
  }

  getSortDirection(columnName: string): string | null {
    return this.currentSortColumns.find(s => s.column === columnName)?.direction ?? null;
  }

  handleRowClicked(row: any) {
    this.rowClicked.emit(row);
  }
}
